import {
  LOAD_TABLE,
  LOAD_TABLE_SUCCESS,
  LOAD_TABLE_FAILURE,
  TableActionTypes,
  TableState,
} from "./table.types";

export const initialTableState: TableState = {
  isLoading: false,
  success: false,
  error: null,
  data: [],
  period: null,
  profile: "",
};

export function tableReducer(
  state = initialTableState,
  action: TableActionTypes
) {
  const { period, profile } = action.payload;

  switch (action.type) {
    case LOAD_TABLE: {
      return {
        ...state,
        isLoading: true,
        success: false,
        error: null,
        period,
        profile,
      };
    }
    case LOAD_TABLE_SUCCESS: {
      if (state.period === period && state.profile === profile) {
        return {
          ...state,
          isLoading: false,
          success: true,
          error: null,
          data: action.payload.data,
        };
      } else {
        return state;
      }
    }
    case LOAD_TABLE_FAILURE:
      if (state.period === period && state.profile === profile) {
        return {
          ...state,
          isLoading: false,
          success: false,
          error: action.payload.error,
          data: [],
        };
      } else {
        return state;
      }
    default:
      return state;
  }
}
